export enum Blockchain {
    ETHEREUM,
    POLYGON
}